export default __webpack_public_path__ + "static/media/tech_insight.46d329a2.png";